import { nextTick, onMounted, reactive, ref, computed, watch } from 'vue'
import {
  TYPE_OPTIONS,
  TIME_OPTIONS,
  BOOL_OPTIONS,
  RULES,
  NOTICE_INFO_COLUMNS
} from './constants'
import { announcementCenter } from '@/apis/18726'
import { announcementPublishPermissionConfig } from '@/apis/18782'
import {
  config_supplier_edit_infos_post,
  dict_list_dict_tree_post
} from '@/server/modules/1890'
import { staff_list_depart_post } from '@/server/modules/4627'
import { message } from 'ant-design-vue'
import { translateDataToTree } from '@/utils/utils'
import { downloadFileNew } from 'utils/file.js'
export const useNoticePublish = () => {
  const tableRef = ref(null)
  const state = reactive({
    scrollY: 500,
    showAddNotice: false,
    showDetail: false,
    showReadingRecord: false,
    showNoticeInfoList: false,
    id: null,
    tableRef,
    hasPermission: false
  })
  onMounted(() => {
    nextTick(() => {
      state.scrollY = window.innerHeight - 100
      console.log(state.scrollY, 'scrolly')
    })
    getUserPermission()
  })
  const updateStatus = async (id, status) => {
    const { success, retInfo } = await announcementCenter.update_status_post({
      id,
      status
    })
    if (success) {
      message.success(retInfo)
      state.tableRef.refresh()
    } else {
      message.error(retInfo)
    }
  }
  const getUserPermission = async () => {
    let vuex = {}
    if (localStorage.getItem('vuex')) {
      vuex = JSON.parse(localStorage.getItem('vuex'))
    }
    const userId = vuex?.user?.userInfo?.userId || 141
    const {
      success,
      retInfo,
      data
    } = await announcementPublishPermissionConfig.page_post({
      userIdList: [userId]
    })
    if (success) {
      if (data?.list?.length) {
        if (data.list[0].status === 1) {
          state.hasPermission = true
        }
      }
      console.log(data)
    } else {
      message.error(retInfo)
    }
  }
  return {
    state,
    tableRef,
    updateStatus
  }
}
export const useAddNotice = (props, state) => {
  const wangeditorRef = ref(null)
  const formRef = ref(null)
  const addNoticeState = reactive({
    title: '',
    formData: { effectives: [] },
    rules: RULES,
    typeOptions: TYPE_OPTIONS,
    timeOptions: TIME_OPTIONS,
    boolOptions: BOOL_OPTIONS,
    canEdit: true,
    wangeditorRef,
    formRef,
    supplierTypeList: [],
    env: process.env.VUE_APP_ENV,
    staffList: [],
    permissions: {},
    cooperationModeList: [],
    supplierTree: []
  })
  onMounted(() => {
    addNoticeState.title = props.id ? '修改公告' : '新增公告'
    querySupplierInfo()
    getSupplierTree()
    staffList()
    getUserScope()
    if (props.id) {
      getDetail()
    }
  })
  const handleChangeSelect = (val, v) => {
    setTimeout(() => {
      if (!addNoticeState.formData?.releaseScopeArr?.includes(v)) {
        addNoticeState.formData.releaseScopeArr.push(v)
      }
    }, 0)
  }
  const getUserScope = async () => {
    const {
      success,
      retInfo,
      data
    } = await announcementPublishPermissionConfig.get_user_scope_get({})
    if (success) {
      console.log(data)
      addNoticeState.permissions = data
    } else {
      message.error(retInfo)
    }
  }
  const querySupplierInfo = async () => {
    const { success, retInfo, data } = await config_supplier_edit_infos_post({
      id: addNoticeState.env === 'production' ? 2805 : 200009
    })
    if (success) {
      addNoticeState.supplierTypeList.forEach(item => {
        item.label = item.name
        item.key = item.id
        item.title = item.name
        item.value = item.id
      })
      addNoticeState.supplierTypeList = translateDataToTree(
        data.supplierTypeList
      )
      addNoticeState.cooperationModeList = data.cooperationMode.map(item => ({
        label: Object.values(item)[0],
        value: Object.values(item)[0]
      }))
    } else {
      message.error(retInfo)
    }
  }
  const getTrees = data => {
    return data.map(item => {
      item.title = item.dictDesc
      item.value = item.dictCode || Math.random().toFixed(4)
      item.key = item.dictCode || item.value
      if (item.children?.length) {
        item.children = getTrees(item.children)
      }
      return item
    })
  }
  const getSupplierTree = async () => {
    const { success, retInfo, data } = await dict_list_dict_tree_post({
      dictType: 8110
    })
    if (success) {
      addNoticeState.supplierTree = getTrees(data)
    } else {
      message.error(retInfo)
    }
  }
  const getDetail = async () => {
    const { success, retInfo, data } = await announcementCenter.detail_post({
      id: props.id
    })
    if (success) {
      if (!data) return
      addNoticeState.formData = data
      if (data.releaseScope) {
        addNoticeState.formData.releaseScopeArr = data.releaseScope.split(',')
      }
      if (data.internalDepartmentScope) {
        addNoticeState.formData.internalDepartmentScopeArr = data.internalDepartmentScope.split(
          ','
        )
      }
      if (data.supplierScope) {
        addNoticeState.formData.supplierScopeArr = data.supplierScope.split(',')
      }
      if (data.effectiveEnd && data.effectiveStart) {
        addNoticeState.formData.effectives = [
          data.effectiveStart,
          data.effectiveEnd
        ]
      }
      if (data.excludeStaff) {
        addNoticeState.formData.excludeStaffArr = data.excludeStaff
          .split(',')
          ?.map(item => Number(item))
      }
      if (data.excludeSupplier) {
        addNoticeState.formData.excludeSupplierArr = data.excludeSupplier
          .split(',')
          ?.map(item => Number(item))
      }
      if (data.cooperationMode) {
        addNoticeState.formData.cooperationModeArr = data.cooperationMode.split(
          ','
        )
      }
      if (data.supplierClassification) {
        addNoticeState.formData.supplierClassificationArr = data.supplierClassification.split(
          ','
        )
      }
    } else {
      message.error(retInfo)
    }
  }
  const publish = async val => {
    formRef.value.validate().then(async () => {
      if (
        addNoticeState.formData.effectiveType === 1 &&
        !addNoticeState.formData.effectives?.length
      )
        return message.error('请选择时间范围')
      if (
        !addNoticeState.formData.releaseScopeArr ||
        !addNoticeState.formData.releaseScopeArr.length
      )
        return message.error('请选择发布范围')
      if (
        addNoticeState.formData.releaseScopeArr?.includes('1') &&
        !addNoticeState.formData.internalDepartmentScopeArr?.length
      )
        return message.error('请选择内部员工')
      if (addNoticeState.formData.releaseScopeArr?.includes('2')) {
        if (!addNoticeState.formData.supplierClassificationArr?.length) {
          return message.error('请选择供应商分类')
        }
        if (!addNoticeState.formData.cooperationModeArr?.length) {
          return message.error('请选择供应商合作模式')
        }
      }
      const str = addNoticeState.formData.content?.replace(
        /<(?!img\s*\/?)[^>]+>/gi,
        ''
      )
      if (!str) return message.error('请输入具体内容')
      const params = {
        ...addNoticeState.formData,
        releaseScope: addNoticeState.formData?.releaseScopeArr?.join(','),
        internalDepartmentScope: addNoticeState.formData?.internalDepartmentScopeArr?.join(
          ','
        ),
        supplierScope: addNoticeState.formData?.supplierScopeArr?.join(','),
        effectiveStart: addNoticeState.formData?.effectives?.length
          ? addNoticeState.formData.effectives[0]
          : '',
        effectiveEnd: addNoticeState.formData?.effectives?.length
          ? addNoticeState.formData.effectives[1]
          : '',
        status: val === 0 ? null : val,
        excludeStaff: addNoticeState.formData?.excludeStaffArr?.join(','),
        excludeSupplier: addNoticeState.formData?.excludeSupplierArr?.join(','),
        cooperationMode: addNoticeState.formData?.cooperationModeArr?.join(','),
        supplierClassification: addNoticeState.formData?.supplierClassificationArr?.join(
          ','
        )
      }
      // console.log(params.content, 'content')
      delete params.releaseScopeArr
      delete params.effectives
      delete params.supplierScopeArr
      delete params.internalDepartmentScopeArr
      delete params.cooperationModeArr
      delete params.supplierClassificationArr
      const ajax = props.id
        ? announcementCenter.update_post
        : announcementCenter.create_post
      const { success, retInfo } = await ajax(params)
      if (success) {
        message.success(retInfo)
        state.showAddNotice = false
        state.tableRef.refresh()
      } else {
        message.error(retInfo)
      }
    })
  }
  const changeReleaseScope = () => {
    if (!addNoticeState.formData.releaseScopeArr?.includes('1')) {
      addNoticeState.formData.internalDepartmentScopeArr = []
    }
    if (!addNoticeState.formData.releaseScopeArr?.includes('2')) {
      addNoticeState.formData.supplierScopeArr = []
    }
  }
  const staffList = async () => {
    const { success, retInfo, data } = await staff_list_depart_post({
      source: 'FS'
    })
    if (success) {
      formatterData(data)
      addNoticeState.staffList = data
      console.log(addNoticeState.staffList, 'addNoticeState.staffList')
    } else {
      message.error(retInfo)
    }
  }
  const formatterData = list => {
    list.forEach(item => {
      item.label = item.name
      item.value = item.departmentId
      if (item.children?.length) {
        formatterData(item.children)
      }
    })
  }

  return {
    addNoticeState,
    wangeditorRef,
    publish,
    formRef,
    changeReleaseScope,
    handleChangeSelect
  }
}
export const useNoticeDetail = (props, emit, store) => {
  const noticeDetailState = reactive({
    previewImage: null,
    isPreview: false,
    videoVisible: false,
    videoUrl: null,
    noticeDetail: {},
    fileUrl: null,
    showpdf: false,
    fileVisible: false
  })
  const showModal = computed(() => props.showDetail)
  const handlePreview = (url, type) => {
    if (type === 1) {
      noticeDetailState.videoUrl = url
      noticeDetailState.videoVisible = true
    } else {
      noticeDetailState.fileUrl = `pdfjs/web/viewer.html?file=${url}`
      noticeDetailState.fileVisible = true
    }
  }
  const getReadDetail = async () => {
    const ajax = props?.isFromNotice
      ? announcementCenter.detail_post
      : announcementCenter.read_detail_post
    const { success, retInfo, data } = await ajax({
      id: props?.id
    })
    if (success) {
      noticeDetailState.noticeDetail = data
      if (noticeDetailState.noticeDetail.popupTime) {
        const timer = setInterval(() => {
          if (!noticeDetailState.noticeDetail.popupTime) {
            clearInterval(timer)
            return
          }
          noticeDetailState.noticeDetail.popupTime--
        }, 1000)
      }
    } else {
      message.error(retInfo)
    }
  }
  const updateReadStatus = async () => {
    const {
      success,
      retInfo
    } = await announcementCenter.update_read_status_post({ id: props.id })
    if (success) {
      message.success(retInfo)
      emit('close')
      props.toRead && props.toRead()
      store.commit('GET_NOTICE_COUNT')
    } else {
      message.error(retInfo)
    }
  }
  const closable = computed(() => {
    let flag = true
    if (props.isFromNotice) {
      flag = true
    } else {
      if (noticeDetailState.noticeDetail?.isReadStr === '已读') {
        flag = true
      } else {
        if (!noticeDetailState.noticeDetail?.popupTime) {
          flag = true
        } else {
          flag = false
        }
      }
    }
    return flag
  })
  onMounted(() => {
    getReadDetail()
  })

  return {
    noticeDetailState,
    handlePreview,
    updateReadStatus,
    showModal,
    closable
  }
}
export const useReadingRecord = props => {
  const readingRecordState = reactive({
    activeKey: 1,
    topMessage: '',
    countInfo: {},
    scrollY: 500
  })
  onMounted(() => {
    nextTick(() => {
      readingRecordState.scrollY = window.innerHeight - 200
      console.log(readingRecordState.scrollY, 'scrolly')
    })
    getNoticecount()
  })
  const exportEvent = async params => {
    const {
      success,
      retInfo,
      data
    } = await announcementCenter.export_read_record_post(params)
    if (success) {
      message.success(retInfo)
      downloadFileNew(data)
    } else {
      message.error(retInfo)
    }
  }
  const getNoticecount = async () => {
    const { success, retInfo, data } = await announcementCenter.count_post({
      announcementId: props.id,
      scopeType: readingRecordState.activeKey
    })
    if (success) {
      readingRecordState.countInfo = data
      if (readingRecordState.activeKey === 1) {
        readingRecordState.topMessage = `接收范围内，内部员工总数量${readingRecordState.countInfo?.totalCount},其中已读数量${readingRecordState.countInfo?.readCount},未读数量${readingRecordState.countInfo?.unreadCount}`
      } else {
        readingRecordState.topMessage = `接收范围内，外部供应商总数量${readingRecordState.countInfo?.totalCount},其中已读数量${readingRecordState.countInfo?.readCount},未读数量${readingRecordState.countInfo?.unreadCount}`
      }
    } else {
      message.error(retInfo)
    }
  }
  watch(
    () => readingRecordState.activeKey,
    () => {
      getNoticecount()
    },
    { immediate: true }
  )
  return {
    readingRecordState,
    exportEvent
  }
}
export const useNoticeInfoList = props => {
  const tableRef = ref(null)
  let vuex = {}
  if (localStorage.getItem('vuex')) {
    vuex = JSON.parse(localStorage.getItem('vuex'))
  }
  const noticeInfoState = reactive({
    tableRef,
    userId: vuex?.user?.userInfo?.userId,
    activeKey: 0,
    scrollY: 500,
    tabList: [
      {
        title: '标准流程&文件',
        key: 0,
        count: 0
      },
      {
        title: '操作指引',
        key: 1,
        count: 0
      },
      {
        title: '系统公告',
        key: 2,
        count: 0
      },
      {
        title: '避坑指南',
        key: 3,
        count: 0
      },
      {
        title: '培训文档',
        key: 4,
        count: 0
      }
    ],
    id: null,
    showDetail: false,
    noticeInfoColumns: NOTICE_INFO_COLUMNS,
    selectedKeys: [],
    searchForm: {
      announceTimeList: [],
      isRead: ''
    }
  })
  onMounted(() => {
    nextTick(() => {
      noticeInfoState.scrollY = window.innerHeight - 100
    })
    getCount()
  })

  const getCount = async () => {
    let vuex = {}
    if (localStorage.getItem('vuex')) {
      vuex = JSON.parse(localStorage.getItem('vuex'))
    }
    const {
      success,
      retInfo,
      data
    } = await announcementCenter.unread_count_post({
      responsibleId: noticeInfoState.userId,
      scopeType: 1,
      ...noticeInfoState.searchForm
    })
    if (success) {
      console.log(data)
      noticeInfoState.tabList.forEach(item => {
        if (item.key === 0) {
          item.count = data?.unreadStandardProcessCount
        }
        if (item.key === 1) {
          item.count = data?.unreadOperatingInstructionsCount
        }
        if (item.key === 2) {
          item.count = data?.unreadSystemAnnouncementCount
        }
        if (item.key === 3) {
          item.count = data?.unreadAvoidingPitsGuideCount
        }
        if (item.key === 4) {
          item.count = data?.unreadTrainingDocumentCount
        }
      })
    } else {
      message.error(retInfo)
    }
  }
  const changeTab = item => {
    noticeInfoState.activeKey = item.key
    tableRef?.value?.refresh({
      ...noticeInfoState.searchForm,
      scopeType: 1,
      type: noticeInfoState.activeKey,
      responsibleId: noticeInfoState.userId
    })
  }
  const refresh = () => {
    tableRef?.value?.refresh({
      ...noticeInfoState.searchForm,
      scopeType: 1,
      type: noticeInfoState.activeKey,
      responsibleId: noticeInfoState.userId
    })
    getCount()
  }
  const reset = () => {
    noticeInfoState.searchForm = {
      isRead: ''
    }
    tableRef?.value?.refresh({
      scopeType: 1,
      type: noticeInfoState.activeKey,
      responsibleId: noticeInfoState.userId
    })
    getCount()
  }
  return {
    noticeInfoState,
    tableRef,
    refresh,
    reset,
    changeTab
  }
}
export const useNoticeModal = (props, emit) => {
  const noticeModalState = reactive({
    showDetail: false,
    content: null
  })

  onMounted(() => {
    const regex = /(<([^>]+)>)|(&nbsp;)/gi
    noticeModalState.content = props.noticeDetailInfo?.content?.replace(
      regex,
      ''
    )
  })
  const showNoticeModal = computed(() => props.visible)
  const checkDetail = () => {
    emit('close')
    emit('openDetail')
  }
  watch(
    () => noticeModalState.showDetail,
    val => {
      console.log(val, 22222)
    },
    {
      immediate: true,
      deep: true
    }
  )

  return {
    noticeModalState,
    checkDetail,
    showNoticeModal
  }
}
